import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import FilterData from 'src/models/recipe/list/filter-data';

// ----------------------------------------------------------------------

type Props = {
  filters: FilterData;
  handleRemoveFilter: (name: string) => void;
};

export default function RecipeAppliedFilters({ filters, handleRemoveFilter }: Props) {
  if (!filters || !filters.canReset()) {
    return null;
  }

  return (
    <Stack
      spacing={2.5}
      direction="row"
      sx={{ my: 1, alignItems: 'center', flexWrap: 'wrap' }}
    >
      <Typography variant="body2">Filtry:</Typography>
      {filters.getActiveFilterFields().map(([filterConfig, filterData]) => (
        <Chip
          key={`applied-filter-${filterConfig.code}`}
          variant="outlined"
          color="primary"
          label={filterConfig.toLabel(filterData)}
          onDelete={() => handleRemoveFilter(filterConfig.code)}
        />
      ))}
    </Stack>
  );
}

